import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { filter, Observable, Subscription } from 'rxjs';
import { CustomerData } from 'src/app/models/customer.model';
import { Statuses } from 'src/app/models/kn-br-quote.model';
import { KnBrCommonService } from 'src/app/services/kn-br-common.service';
import { KnBrCustomerContextService } from 'src/app/store/kn-br-customer-context/kn-br-customer-context.service';
import { NgSelectComponent, NgOptionTemplateDirective, NgMultiLabelTemplateDirective } from '@ng-select/ng-select';
import { SlicePipe } from '@angular/common';
import { TranslatePipe } from '@spartacus/core';
@Component({
    selector: 'knbr-kn-br-find-my-contact-search',
    templateUrl: './kn-br-find-my-contact-search.component.html',
    styleUrl: './kn-br-find-my-contact-search.component.scss',
    imports: [
        ReactiveFormsModule,
        NgSelectComponent,
        NgOptionTemplateDirective,
        FormsModule,
        NgMultiLabelTemplateDirective,
        SlicePipe,
        TranslatePipe,
    ],
})
export class KnBrFindMyContactSearchComponent implements OnInit, OnDestroy {
  allSubscriptions = new Subscription();
  customerNumber = '';
  hasContext = false;
  accountNumber = [];
  selectedCustomer: CustomerData;
  findMyContactSearchForm: UntypedFormGroup;
  customerContextData$: Observable<CustomerData> = this.knBrCustomerContextService.get$;
  //customersDataList$: Observable<any> = this.knBrCommonService.loadCustomersData$();
  //brandSalesShipToList$: Observable<Statuses[]> = this.knBrCommonService.loadBrandSalesShipToList$();
  brandList$: Observable<Statuses[]> = this.knBrCommonService.loadBrandList$();
  FMC_Role = [];
  result = [];
  constructor(
    protected fb: UntypedFormBuilder,
    protected knBrCustomerContextService: KnBrCustomerContextService,
    protected knBrCommonService: KnBrCommonService,
    protected activatedRoute: ActivatedRoute
  ) {}
  ngOnInit(): void {
    this.knBrCommonService.getFMCRoleList();
    this.allSubscriptions.add(
      this.customerContextData$.subscribe((value) => {
        if (value) {
          this.hasContext = true;
          this.selectedCustomer = value;
          this.customerNumber = this.selectedCustomer.customerNumber ? this.selectedCustomer.customerNumber : null;
        }
        this.knBrCommonService.getBrandList();
        this.handleBrandListResponse();

        this.initForm();
      })
    );
    this.allSubscriptions.add(
      this.knBrCommonService
        .loadFMCRoleList$()
        .pipe(filter(Boolean))
        .subscribe((res: any) => {
          if (res) {
            this.FMC_Role = res;
          }
        })
    );
  }
  handleBrandListResponse() {
    this.allSubscriptions.add(
      this.brandList$.subscribe((response: any) => {
        if (response) {
          this.result = Object.keys(response).map((key) => ({ name: response[key], value: key }));
        }
      })
    );
  }

  initForm() {
    this.findMyContactSearchForm = this.fb.group({
      accountNumber: [
        {
          value:
            this.selectedCustomer && this.selectedCustomer.customerNumber
              ? this.knBrCommonService.combineCustomerData(this.selectedCustomer)
              : null,
          disabled: this.selectedCustomer ? true : false,
        },
      ],
      brand: [null, Validators.required],
      role: [null, Validators.required],
    });
  }
  submitForm() {
    if (this.findMyContactSearchForm.valid) {
      const { ...payload } = this.findMyContactSearchForm.getRawValue();
      const updatedPayload = { ...payload };
      updatedPayload.accountNumber =
        payload.accountNumber && Array.isArray(payload.accountNumber) && payload.accountNumber.length
          ? payload.accountNumber.map((eachacc) => eachacc.Key).join(',')
          : this.selectedCustomer?.customerNumber;
      updatedPayload.roles =
        payload.role && payload.role.length
          ? payload.role.map((eachStatus) => eachStatus.split(':')[0]).join(',')
          : null;
      updatedPayload.salesArea =
        payload.brand && payload.brand.length ? payload.brand.map((eachBrand) => eachBrand.value).join(',') : null;
      this.knBrCommonService.getContactInfo(
        updatedPayload.accountNumber,
        updatedPayload.roles,
        updatedPayload.salesArea
      );
    }
  }
  resetForm() {
    this.findMyContactSearchForm.get('brand')?.reset();
    this.findMyContactSearchForm.get('role')?.reset();
    this.knBrCommonService.contactInfo$.next([]);
    this.knBrCommonService.searchTriggered$.next(false);
  }

  ngOnDestroy(): void {
    this.allSubscriptions?.unsubscribe();
    this.knBrCommonService.contactInfo$.next([]);
    this.knBrCommonService.brandList$.next([]);
  }
}
